/* eslint-disable no-magic-numbers */
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { MessageHandlerService } from '@core/services/message-handler/message-handler.service';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const unauthorized = 401;
  const messageHandlerService = inject(MessageHandlerService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err instanceof HttpErrorResponse) {
        // Handle HTTP errors
        if (err.status === unauthorized) {
          inject(AuthenticationService).initializeLogout();
          messageHandlerService.errorMessage(err.error.errors[0]?.message);
        } else if (err.status === 403) {
          messageHandlerService.errorMessage(err.message);
        } else {
          messageHandlerService.errorMessage(err.error.errors[0]?.message);
        }
      } else {
        // Handle non-HTTP errors
        console.error('An error occurred:', err);
      }
      // Re-throw the error to propagate it further
      return throwError(() => err);
    })
  );
};
